export const Arrow = ({ color, className }) => (
  <svg className={className} width='10' height='17' viewBox='0 0 10 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.390472 7.51964C-0.130157 8.04027 -0.130157 8.88577 0.390472 9.4064L7.05454 16.0705C7.57517 16.5911 8.42067 16.5911 8.9413 16.0705C9.46193 15.5498 9.46193 14.7043 8.9413 14.1837L3.21853 8.46094L8.93713 2.73817C9.45776 2.21754 9.45776 1.37204 8.93713 0.85141C8.4165 0.33078 7.571 0.33078 7.05037 0.85141L0.386307 7.51547L0.390472 7.51964Z'
      fill={color}
    />
  </svg>
);
